import { createContext, PropsWithChildren } from 'react'

export const IsInModalContext = createContext(false)
export const ModalContextProvider = ({ children }: PropsWithChildren) => (
  <IsInModalContext.Provider value={true}>{children}</IsInModalContext.Provider>
)
